import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home.js';
import { gamesData } from "./data/projects";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home games={[
          gamesData.gameJams.find(g => g.id === "boss"),
          gamesData.gameJams.find(g => g.id === "bean"),
          gamesData.personalProjects.find(g => g.id === "boids"),
          gamesData.gameJams.find(g => g.id === "monkey"),
          gamesData.personalProjects.find(g => g.id === "jam"),
          gamesData.personalProjects.find(g => g.id === "metal"),
        ]} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
